export default __webpack_public_path__ + "static/media/flowerOne.bd358a10.png";